export default "__VITE_ASSET__CrmVdzRL__"